import { Box, Grid, Typography, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
// import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
// import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
// import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { topbarStyles } from "../components/TopStyles";
import { wholesalerViewRequest } from "../../redux/wholesaler/WholesalerAction";
import { convertImageToBase64 } from "../constant/commonFileUpload";
import { useForm } from "react-hook-form";

const Topbar = () => {
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const { setValue } = useForm();

  const user = useSelector((state) => state?.values?.loginValues?.[0] || {});
  // const userName =
  //   user?.first_name && user?.last_name
  //     ? `${user.first_name} ${user.last_name}`
  //     : null;

  const userType = user?.user_type;
  const wholesalerViewAllState = useSelector(
    (state) => state?.wholesaler?.viewWholesaler?.data || {}
  );

  const wholesalerList = wholesalerViewAllState || [];

  const firstLetter = user?.first_name
    ? user.first_name.charAt(0).toUpperCase()
    : "";

  const userName =
    user?.user_type === "3"
      ? `${wholesalerList?.first_name || ""} ${
          wholesalerList?.last_name || ""
        }`.trim()
      : `${user?.first_name || ""} ${user?.last_name || ""}`.trim();

  // Function to truncate name if longer than 15 characters
  const getDisplayName = (fullName) => {
    if (fullName.length > 15) {
      return fullName.substring(0, 10) + "...";
    }
    return fullName;
  };

  const displayName = getDisplayName(userName);
  const shouldShowTooltip = userName.length > 15;

  const profileImage =
    userType === "3" && imagePreview ? (
      <img src={imagePreview} alt="Profile" style={topbarStyles.profileImage} />
    ) : (
      <Box sx={topbarStyles.adminProfileImage}>{firstLetter}</Box>
    );

  useEffect(() => {
    if (user?.wholesaler_id) {
      dispatch(wholesalerViewRequest(user?.wholesaler_id));
    }
  }, [user?.wholesaler_id, dispatch]);

  useEffect(() => {
    setValue("first_name", wholesalerList?.first_name);
    setValue("last_name", wholesalerList?.last_name);
    if (wholesalerList?.prof_image) {
      const imageUrl = wholesalerList.prof_image;

      if (imageUrl.startsWith("data:image")) {
        setSelectedFile(imageUrl.split(",")[1]);
        setImagePreview(imageUrl);
      } else {
        convertImageToBase64(imageUrl).then((base64) => {
          if (base64) {
            setSelectedFile(base64);
            setImagePreview(`data:image/png;base64,${base64}`);
          }
        });
      }
    }
  }, [wholesalerList, setValue]);

  return (
    <Box p={2} sx={topbarStyles.topbarContainer}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={12} sm={5} md={5} lg={5} xl={5}></Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={2}
            sx={topbarStyles.rightMenu}
          >
            {/* Notifications Icon */}
            {/* <Badge badgeContent={3} color="secondary" overlap="rectangular">
              <IconButton sx={topbarStyles.notificationButton}>
                <NotificationsOutlinedIcon sx={topbarStyles.notificationIcon} />
              </IconButton>
            </Badge> */}

            {/* Settings Icon */}
            {/* <Badge badgeContent="!" color="error" overlap="rectangular">
              <IconButton sx={topbarStyles.settingsButton}>
                <SettingsOutlinedIcon sx={topbarStyles.settingsIcon} />
              </IconButton>
            </Badge> */}

            {/* Profile Section */}
            <Box sx={topbarStyles.profileContainer}>
              <Box sx={topbarStyles.profileBox} />
              {shouldShowTooltip ? (
                <Tooltip
                  title={userName}
                  placement="bottom"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: "14px",
                        padding: "8px 12px",
                        maxWidth: "300px",
                        backgroundColor: "rgba(7, 79, 146, 0.9)",
                        color: "white",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(53, 150, 214, 0.2)",
                      },
                    },
                  }}
                >
                  <Typography sx={topbarStyles.profileText}>
                    {displayName}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography sx={topbarStyles.profileText}>
                  {displayName}
                </Typography>
              )}

              {/* <Typography sx={topbarStyles.profileText}>
                {loginState?.user && loginState?.user?.first_name}
              </Typography>{" "} */}
              <Box sx={topbarStyles.profileImageContainer}>{profileImage}</Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Topbar;
